import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';

import { CloseButton } from '~/content/components/Editor/styles';
import { getHumanReadableSize } from '~/composer/composer/utils/StringUtils';
import { Upload } from '../../entities/Upload';
import {
  StyledOverlay,
  ModalWrapper,
  InnerWrapper,
  MediaContainer,
  FileSize,
  Image,
  Video,
} from './styles';
import ImageDescription from './ImageDescription';

const MediaPreviewer = ({
  upload,
  onClose,
}: {
  upload: Upload;
  onClose: () => void;
}) => (
  <>
    <StyledOverlay />
    <ModalWrapper>
      <InnerWrapper>
        {(Upload.isImage(upload) || Upload.isGif(upload)) && (
          <>
            <MediaContainer>
              <Image alt={upload.alt} src={upload.url} />
            </MediaContainer>
            <ImageDescription upload={upload} onClose={onClose} />
          </>
        )}
        {Upload.isVideo(upload) && (
          <MediaContainer>
            <Video poster={upload.thumbnailUrl} controls src={upload.url}>
              <track kind="captions" />
            </Video>
            <FileSize>{getHumanReadableSize(upload.size)}</FileSize>
          </MediaContainer>
        )}
        <Dialog.Close asChild>
          <CloseButton size="large" />
        </Dialog.Close>
      </InnerWrapper>
    </ModalWrapper>
  </>
);

MediaPreviewer.propTypes = {};

export default MediaPreviewer;
